module.exports = __webpack_public_path__ + "static/media/(V)_MG_4985_-_Pro-Natura_-_Moda_Feminina_-_acessorios.2184a084.jpg";